import { formatToCurrency } from '@betgames/bg-tools';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';

interface ICurrencyFormatOptions {
    removeTrailingZeroes?: boolean;
    subunit?: number;
    reverseTemplate?: boolean;
}

export interface ICurrencyFormat {
    (amount: number | string, options?: ICurrencyFormatOptions): string;
}

export const formatToUserCurrency: ICurrencyFormat = (
    amount,
    { removeTrailingZeroes = false, subunit = 0, reverseTemplate = false } = {},
) => {
    const { currency } = partnerSettingsStore;
    const actualAmount = subunit ? Number(amount) / 10 ** subunit : amount;
    const template = reverseTemplate
        ? [[...currency.template].filter((value) => value !== 'X'), 'X'].flat().join('')
        : currency.template;

    return formatToCurrency(
        actualAmount,
        currency.precision,
        template,
        currency.code,
        removeTrailingZeroes,
    );
};
